import { Box, makeStyles, Theme, Typography } from '@material-ui/core';
import { LedSubmitButton } from 'components/led/atoms';
import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';
import ledStores from 'stores/led';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(8, 5),
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(10, 5),
    },
  },
}));

const StartPointSection: FC = observer(() => {
  const classes = useStyles();
  const { startPointStore } = ledStores;
  const { isLoading } = startPointStore;

  return (
    <Box className={classes.root}>
      <Typography variant="h2">Starting point</Typography>
      <Box mb={10} />
      <LedSubmitButton
        loading={isLoading}
        onClick={() => {
          console.log('No implementation');
        }}
      >
        Start new project
      </LedSubmitButton>
    </Box>
  );
});

export default StartPointSection;
